//const URLASSOLUTO = process.env.MIX_URLASSOLUTO;
//export { URLASSOLUTO };
const URLASSOLUTO = window.URLASSOLUTO;
const CURRENTROUTENAME = window.CURRENTROUTENAME;
delete window.URLASSOLUTO;
delete window.CURRENTROUTENAME;

export { URLASSOLUTO, CURRENTROUTENAME };
